import $ from 'jquery';

export function getBarcode(source, width, displayValue) {

	let barcode = document.createElement('img');
	$(barcode).attr({
		style: "height: 50px; width:100%; display:none;",
		id: "barcode"
	});
	document.body.appendChild(barcode);
	const confObject = {
		format: "CODE128",
		height: 60	
	}
	if (width != undefined) {
		confObject.width = width;
	}
	if (displayValue != undefined) {
		confObject.displayValue = displayValue;
	}
	window.JsBarcode("#barcode", source, confObject);
	return $(barcode)[0].src;	
}
